import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "preferred-store-button",
  class PreferredStoreButton extends WYATTElement {
    constructor() {
      super();

      this.makePreferred = this.querySelector("[data-make-preferred]");
      this.isPreferred = this.querySelector("[data-is-preferred]");

      this.makePreferred.removeAttribute("disabled");
      this.makePreferred.addEventListener("click", this.handleClick.bind(this));
    }

    connectedCallback() {
      if (!this.store?.id) {
        this.togglePreferred(this.store?.id);
      }

      this.subscribe(
        WYATT.PubSub.events.preferredStoreSet,
        this.handlePreferredStoreSet.bind(this),
      );
    }

    get store() {
      const storeStr = WYATT.shopify.cart?.attributes?.store || null;
      try {
        return JSON.parse(storeStr);
      } catch (e) {
        return null;
      }
    }

    handleClick(event) {
      event.preventDefault();

      WYATT.PreferredStores.setStore(this.config.store);
    }

    togglePreferred(id) {
      if (!id || !this.config.store.id) {
        this.makePreferred.classList.remove("hidden");
        this.isPreferred.classList.add("hidden");
      }

      if (this.config.store.id === id) {
        this.makePreferred.classList.add("hidden");
        this.isPreferred.classList.remove("hidden");
      } else {
        this.makePreferred.classList.remove("hidden");
        this.isPreferred.classList.add("hidden");
      }
    }

    handlePreferredStoreSet(store) {
      if (!store) {
        return;
      }
      this.togglePreferred(store.id);
    }
  },
);
